// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateShipment_container__1e4n4"};